import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { isStagingBranch } from "./IsStagingBranch";
import {
  FIREBASE_CLIENT_CONFIG_DEV,
  FIREBASE_CLIENT_CONFIG_PROD,
  FIREBASE_PROD_FALLBACK_AUTH_DOMAIN,
} from "../../src/shared/firebaseClientConfig";

/**
 * Staging URLs cannot be used for OAuth when self-hosting Firebase auth handlers
 * To do this, we'd have to whitelist every single one with both Google and Facebook
 * as authorized redirect URIs. This is not feasible.
 *
 * Therefore, we use the Firebase project domain to handle auth with staging.
 *
 * However, this results in errors when using signInWithRedirect due to third-party cookies.
 * To fix this, we detect when we're on a staging branch and use signInWithPopup instead.
 * (Dev also uses signInWithPopup via its firebaseapp.com authDomain.)
 */
const firebaseConfig =
  process.env.NODE_ENV === "development" || process.env.REACT_APP_NODE_ENV === "development"
    ? FIREBASE_CLIENT_CONFIG_DEV
    : {
        ...FIREBASE_CLIENT_CONFIG_PROD,
        authDomain: isStagingBranch() ? FIREBASE_PROD_FALLBACK_AUTH_DOMAIN : FIREBASE_CLIENT_CONFIG_PROD.authDomain,
      };

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.firestore().settings({ experimentalAutoDetectLongPolling: true });
// firebase.firestore().enablePersistence({ synchronizeTabs: true });
// firebase.firestore().enablePersistence(false);
export const db = firebase.firestore();

export default firebase;
